import FeaturedCompetitionNavMenu from "./featuredCompetitionNavMenu";
import { useCompetitionByType } from "../../redux/features/categories/selectors";

const FeaturedCompetitions = ({ headerText }: { headerText?: string }) => {
  const featuredCategory = useCompetitionByType("featured");
  return (
    <div className="featured-competitions-nav-menu-container">
      <span className="uppercase text-[#696971] lg:font-semibold lg:text-sm font-bold text-[0.625rem] font-jost leading-tight">
        {headerText ? headerText : "Featured Competitions"}
      </span>
      <ul className="flex flex-col gap-2 mt-3">
        {featuredCategory?.competitions?.map(competition => (
          <FeaturedCompetitionNavMenu key={competition.Title} {...competition} />
        ))}
      </ul>
    </div>
  );
};

export default FeaturedCompetitions;
